import React from 'react';
import { HubspotForm } from '../form/HubspotForm';
import * as styles from './hubspotFormSection.module.scss';

type HubspotFormSectionProps = {
  portalId: string;
  formId: string;
  region: string;
};

export const HubspotFormSection: React.FC<HubspotFormSectionProps> = ({ portalId, formId, region }) => {
  return (
    <div className={styles.wrapper}>
      <HubspotForm
        portalId={portalId}
        formId={formId}
        region={region}
      />
    </div>
  );
}; 